import { render } from "./index.vue?vue&type=template&id=0c8571fe&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0c8571fe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/LabSolver/LabSolver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8571fe"]])

export default __exports__